import Header from './components/commons/Header/Header.jsx';
import Home from './components/views/Home/Home.jsx';
import SalesCatalogue from './components/views/SalesCatalogue/SalesCatalogue.jsx';
import CommonsCatalogue from './components/views/CommonsCatalogue/CommonsCatalogue.jsx';
import NewsCatalogue from './components/views/NewsCatalogue/NewsCatalogue.jsx';
import Footer from './components/commons/Footer/Footer.jsx';
import { Routes, Route } from 'react-router-dom';
import { useState, useEffect } from 'react';
import emailjs from 'emailjs-com';
import './App.css';

const App = () => {

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 720);

  useEffect(() => {
      const handleResize = () => {
          setIsMobile(window.innerWidth <= 720);
      };
      window.addEventListener('resize', handleResize);
      return () => {
          window.removeEventListener('resize', handleResize);
      };
  }, []);

  useEffect(() => {
    emailjs.init('asRKDa7vBP5DwKnua');
  }, [])

  return (
    <div className="App">
        <Header isMobile={isMobile}/>
        <Routes>
          <Route path="/" element={<Home isMobile={isMobile} />}/>          
          <Route path="/ofertas" element={<SalesCatalogue isMobile={isMobile} />}/>    
          <Route path="/productos" element={<CommonsCatalogue isMobile={isMobile} />}/> 
          <Route path="/novedades" element={<NewsCatalogue isMobile={isMobile} />}/>          
        </Routes>
        <Footer isMobile={isMobile} />
    </div>
  );
};

export default App;
